<template>
  <div
    class="ag-card-container"
    :style="`width: ${width};`"
    :data-rounded-top="hasRoundedTop"
    :data-rounded-bottom="hasRoundedBottom"
    :data-borderless="borderless"
  >
    <div v-if="$slots.header" class="ag-card-container__header">
      <slot name="header" />
    </div>

    <slot />

    <div v-if="$slots.footer" class="d-flex justify-end ga-4 mt-4"><slot name="footer" /></div>
  </div>
</template>

<script>
export default {
  props: {
    hasRoundedTop: {
      type: Boolean,
      default: false,
    },

    hasRoundedBottom: {
      type: Boolean,
      default: true,
    },

    borderless: {
      type: Boolean,
      default: false,
    },

    width: {
      type: String,
      default: '100%',
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-card-container {
  padding: $spacing-inset-05;
  border: $border-width-hairline $border-default $neutral-color-low-dark;
  background: $neutral-color-low-light;

  color: $neutral-color-high-dark;

  &[data-rounded-top='true'] {
    border-top-left-radius: $border-radius-sm;
    border-top-right-radius: $border-radius-sm;
  }

  &[data-rounded-bottom='true'] {
    border-bottom-left-radius: $border-radius-sm;
    border-bottom-right-radius: $border-radius-sm;
  }

  &[data-borderless='true'] {
    border: none;
  }

  .ag-card-container__header {
    width: 100%;
    display: flex;
    color: $brand-color-primary-medium;
    font-size: $font-size-sm;
  }
}
</style>
